var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ku-apply"},[_c('div',{staticClass:"word"},[_c('span',[_vm._v("非常重要的资金安全")]),_c('label',[_vm._v("由中国领先的持牌支付科技公司汇付天下提供支付结算，标准费率0.38%，T+1自动到账，安全又稳定。"),_c('br'),_c('font',[_vm._v("不需要汇付支付的，可以自备pos，只能用收银及厨显功能")])],1)]),_c('Apply'),_c('div',{staticClass:"ku-shop-s2"},[_c('span',{on:{"click":_vm.apply}},[_vm._v("老版申请")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }